import services from '@/services/ascentiaServiceIndex'
import { ISSUE_TYPE_CONSTS as ITC } from '../consts'

const state = {
  issueTypes: [],
}

const mutations = {
  [ITC.UPDATE_ISSUE_TYPES]: (state, data) => (state.issueTypes = data),
}

const actions = {
  async [ITC.GET_ISSUE_TYPES]({ commit }) {
    try {
      const response = await services.issueType.getData(
        'issueTypes',
        null,
        true,
      )
      if (response.data) {
        const data = response.data.map(item => {
          return {
            value: item.id,
            text: item.name,
          }
        })
        commit(ITC.UPDATE_ISSUE_TYPES, data)
      }
    } catch (error) {
      console.log(`${[ITC.GET_ISSUE_TYPES]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
